import axios from 'axios';

import { CDN_BASE_URL } from '@/settings';

class Maintenance {
  public async getMaintenanceMessage(): Promise<{ message: string }> {
    const response = await axios.get(`${CDN_BASE_URL}/maintenance-message.json`);

    return response?.data;
  }
}

const maintenanceService = new Maintenance();
export default maintenanceService;
